import React from 'react';
import { useGame } from '../contexts/GameContext';
const Minimap = ({
  npcs,
  worldWidth = 1200,
  worldHeight = 800
}) => {
  const {
    playerPosition
  } = useGame();
  const minimapWidth = 200;
  const minimapHeight = 150;
  // Calculate scale factors
  const scaleX = minimapWidth / worldWidth;
  const scaleY = minimapHeight / worldHeight;
  // Convert world coordinates to minimap coordinates
  const toMinimapX = x => x * scaleX;
  const toMinimapY = y => y * scaleY;
  return <div className="absolute bottom-4 bg-gray-900 bg-opacity-80 border-2 border-gray-700 rounded-lg p-2" style={{
    right: '340px',
    width: `${minimapWidth}px`,
    height: `${minimapHeight}px`
  }} data-id="element-124">
      {/* Title */}
      <div className="absolute -top-6 left-0 text-white text-xs font-semibold" data-id="element-125">
        Minimap
      </div>
      {/* Minimap content */}
      <div className="relative w-full h-full bg-slate-800 rounded" data-id="element-126">
        {/* Grid lines */}
        <div className="absolute inset-0" style={{
        backgroundImage: `
              linear-gradient(rgba(100, 116, 139, 0.2) 1px, transparent 1px),
              linear-gradient(90deg, rgba(100, 116, 139, 0.2) 1px, transparent 1px)
            `,
        backgroundSize: '20px 20px'
      }} data-id="element-127" />
        {/* NPCs */}
        {npcs.map(npc => <div key={npc.id} className="absolute w-2 h-2 rounded-full" style={{
        left: `${toMinimapX(npc.x)}px`,
        top: `${toMinimapY(npc.y)}px`,
        backgroundColor: npc.color,
        transform: 'translate(-50%, -50%)',
        boxShadow: `0 0 4px ${npc.color}`
      }} data-id="element-128" />)}
        {/* Player */}
        <div className="absolute w-3 h-3 rounded-full bg-green-500 animate-pulse" style={{
        left: `${toMinimapX(playerPosition.x)}px`,
        top: `${toMinimapY(playerPosition.y)}px`,
        transform: 'translate(-50%, -50%)',
        boxShadow: '0 0 8px rgba(76, 175, 80, 0.8)',
        zIndex: 10
      }} data-id="element-129" />
        {/* Legend */}
        <div className="absolute bottom-1 left-1 text-[10px] text-gray-400 space-y-0.5" data-id="element-130">
          <div className="flex items-center gap-1" data-id="element-131">
            <div className="w-2 h-2 rounded-full bg-green-500" data-id="element-132"></div>
            <span data-id="element-133">You</span>
          </div>
          <div className="flex items-center gap-1" data-id="element-134">
            <div className="w-2 h-2 rounded-full bg-blue-500" data-id="element-135"></div>
            <span data-id="element-136">NPC</span>
          </div>
        </div>
      </div>
    </div>;
};
export default Minimap;